// Отметка «новое»: в заказе что-то произошло, а покупатель его после этого не открывал
// (регресс 26.10.2026, production-server, решение 18). Позитивный цвет, не тревога.
import styles from "./NewsMark.module.css";

export function NewsMark() {
  return (
    <span className={styles.mark}>
      <span className={styles.dot} aria-hidden="true" />
      новое
    </span>
  );
}
